module.exports = __webpack_public_path__ + "img/big-img-first-block.495c5da6.png";